// Whether this device is in the middle of seeding the course (docs/areas/learn.md). The course shows up
// record by record while it lands, so Learn home does not deal a deck until it has finished: a deck
// built from half a seed would be missing the questions that have not been written yet.
import { create } from 'zustand'

export const useSeeding = create<{ on: boolean; set(on: boolean): void }>((set) => ({
  on: false,
  set: (on) => set({ on }),
}))
